import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function ResumenSemanalPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="dashboard"
      subsectionPath="resumen-semanal"
    />
  );
}
